module.exports = __webpack_public_path__ + "img/course_0014.43c41c3.png";